<template>
  <div>
    <el-upload
      v-loading="loading"
      class="uploader"
      :action="action"
      :with-credentials="true"
      :multiple="true"
      :show-file-list="true"
      :file-list="fileList"
      :limit="9"
      :headers="headers"
      list-type="picture-card"
      name="image"
      accept="image/*"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-remove="handleRemove"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { getLocale } from "@/utils/locale";
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      action: process.env.VUE_APP_BASE_API + "/api/upload",
      loading: false,
    };
  },
  computed: {
    headers() {
      const userToken = getToken();
      const locale = getLocale();
      return {
        "X-User-Token": userToken || "",
        "X-User-Locale": locale || "",
      };
    },
    fileList() {
      if (this.value) {
        try {
          return JSON.parse(this.value);
        } catch (e) {
          console.log(e);
          return [];
        }
      }
      return [];
    },
  },
  methods: {
    handleSuccess(res, file) {
      this.loading = false;
      if (!res.success) {
        this.$message.error(res.message || "上传失败");
        this.loading = false;
        return;
      }

      const list = [];
      if (this.fileList && this.fileList.length) {
        list.push(...this.fileList);
      }
      list.push(res.data);

      this.$emit("input", JSON.stringify(list));
      this.$message.success("上传成功");
    },
    handleRemove(file, list) {
      this.$emit("input", JSON.stringify(list));
    },
    handleError() {
      this.loading = false;
    },
    handleBeforeUpload() {
      this.loading = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
